/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ScheduleQueryResult from './ScheduleQueryResult';

/**
 * The ScheduleOutputCmsSchedule model module.
 * @module model/ScheduleOutputCmsSchedule
 * @version 1.0
 */
class ScheduleOutputCmsSchedule {
    /**
     * Constructs a new <code>ScheduleOutputCmsSchedule</code>.
     * @alias module:model/ScheduleOutputCmsSchedule
     */
    constructor() { 
        
        ScheduleOutputCmsSchedule.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduleOutputCmsSchedule</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduleOutputCmsSchedule} obj Optional instance to populate.
     * @return {module:model/ScheduleOutputCmsSchedule} The populated <code>ScheduleOutputCmsSchedule</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduleOutputCmsSchedule();

            if (data.hasOwnProperty('schedule')) {
                obj['schedule'] = ScheduleQueryResult.constructFromObject(data['schedule']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/ScheduleQueryResult} schedule
 */
ScheduleOutputCmsSchedule.prototype['schedule'] = undefined;






export default ScheduleOutputCmsSchedule;

